export class StockInListQuery {
    constructor(public Period?, public FromDate?, public ToDate?) { }
}